import clsx from 'clsx';
import { Skeleton } from './Skeleton';
import { SkeletonRegion } from './SkeletonRegion';

/** Relative widths, so the columns shrink with the screen and never scroll the page at 390px. */
const COLUMN_WIDTHS = ['w-1/4', 'w-1/5', 'w-1/6', 'w-1/6', 'w-1/12'];

interface TableSkeletonProps {
  label: string;
  rows?: number;
  /** Show the `<ListSearch>` box above the table, as the server-paged list screens do. */
  withSearch?: boolean;
}

/** A list screen's first load: search box, header row and body rows in the table's own frame. Later pages keep the old rows up with Table `loading` instead. */
export function TableSkeleton({ label, rows = 8, withSearch = false }: TableSkeletonProps) {
  return (
    <SkeletonRegion label={label} className="flex flex-col gap-4">
      {withSearch && <Skeleton className="h-8 w-full md:max-w-sm" />}
      <div className="overflow-hidden rounded-lg border border-line bg-surface">
        <div className="flex gap-6 border-b border-line bg-page/60 px-4 py-3.5">
          {COLUMN_WIDTHS.map((width, column) => (
            <Skeleton key={column} className={clsx('h-3', width)} />
          ))}
        </div>
        {Array.from({ length: rows }, (_, row) => (
          <div key={row} className="flex items-center gap-6 border-b border-line px-4 py-4 last:border-0">
            {COLUMN_WIDTHS.map((width, column) => (
              <Skeleton key={column} className={clsx('h-4', width)} />
            ))}
          </div>
        ))}
      </div>
    </SkeletonRegion>
  );
}
